<!--弹出的确认框-->
<template>
  <transition name="fade">
    <div class="dialog" v-show="isConfirmShow" @click="cancel">
        <div class="model">
            <h3 class="mo-title">{{confirmTitle}}
                <span class="mo-close" @click="cancel">×</span>
            </h3> 
            <div class="mo-item mo-warn-box">
              <span class="mo-warn">!</span>
              <span v-html="confirmText"></span>
            </div>
            <div class="handel">
                <div class="cancel" @click.stop="cancel">{{cancelText}}</div>
                <div class="sure" @click.stop="sure">{{sureText}}</div>
            </div>
        </div>
    </div>
  </transition>
</template>
<script>
export default {
    props: {
        sureText: {
            type: String,
            default: "确定"
        },
        cancelText: {
            type: String,
            default: "取消"
        }
    },
    data(){
        return {
            confirmText: "",
            isConfirmShow: false,
            confirmTitle: "提示",
        }
    },
    methods: {
        //取消
        cancel(){
            this.$emit("handelConfirm",{isShow: false,handel: false});
        },
        //确定
        sure(){
            this.$emit("handelConfirm",{isShow: false, handel: true});
        },
        openConfirm(text,title="提示"){
            this.confirmText = text;
            this.confirmTitle = title;
            this.isConfirmShow = true;
        },
        closeConfirm(){
            this.isConfirmShow = false;
        }
    }
}
</script>
<style scoped>
.dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.4);
    z-index: 9999;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}
.model{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 620px;
    padding-bottom: 40px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
}
.mo-title {
  line-height: 80px;
  height: 80px;
  font-size: 18px;
  color: #333;
  text-align: center;
  position: relative;
  border-bottom: 1px solid #e7e7e7;
}
.mo-close {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 40px;
  line-height: 1;
  color: #999;
  cursor: pointer;
}

.mo-close:hover {
  color: #666;
}
.mo-item{
    padding: 40px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    margin-bottom: 15px;
    position: relative;
}
.mo-warn-box {
  line-height: 1.5;
  font-size: 16px;
}

.mo-warn {
  font-size: 42px;
  display: inline-block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
  text-align: center;
  line-height: 48px;
  margin-right: 20px;
}
.handel{
    display: flex;
    justify-content: center;
    text-align: center;
}
.handel div{
    width: 150px;
    height: 40px;
    line-height: 38px;
    border-radius: 20px;
    box-sizing: border-box;
    border: 1px solid #ff9933;
    cursor: pointer;
}
.sure {
  background-color: #ff9933;
  color: #fff;
  margin-left: 30px;
}

.sure:hover {
  background-color: #ff8833;
}

.cancel {
  color: #999;
}

.cancel:hover {
  background-color: #fbfbfb;
}
.fade-enter-active,
.fade-leave-active {
    transition: all .3s ease-in-out;
}
.fade-enter,.fade-leave-active{
    opacity: 0;

}
</style>



// WEBPACK FOOTER //
// src/components/common/confirm.vue